// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-069fe3e6] { padding: 20px;\n}\n.filter-container[data-v-069fe3e6] { margin-bottom: 20px;\n}\n.action-bar[data-v-069fe3e6] { margin-bottom: 15px;\n}\n.pagination-container[data-v-069fe3e6] { margin-top: 20px; text-align: right;\n}\n", ""]);
